import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "printer",
  "use": "printer-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"printer\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 7V1.5a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5V7h-.5a.5.5 0 000 1h11a.5.5 0 000-1H13zM1 4h.5a.5.5 0 000-1h-1a.5.5 0 00-.5.5v9a.5.5 0 00.5.5H4v1.5a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V13h3.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5h-1a.5.5 0 000 1h.5v8h-3v-1.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5V12H1V4zm3-2v5h8V2H4zm1 9h6v3H5v-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol